//#region import
import React from 'react';
import { Colors } from '_styles';
import logo from "_assets/images/PRM-Logo-PNG/white-icon.png";
import { FiLogOut } from "react-icons/fi";
import { useHistory } from 'react-router-dom';
import { SidebarIcon } from '_molecules';
// redux
import { useDispatch } from 'react-redux';
import { logout, reset, resetStatus } from '_redux/slices/main-screen/user';
import { reset as HistoryReset } from '_redux/slices/assistance-bookings/bookings-history';
import { reset as TableReset } from '_redux/slices/prm-bookings/bookings-table';
import { reset as BookingsReset } from '_redux/slices/prm-bookings/bookings';
import { reset as CalendarReset } from '_redux/slices/prm-bookings/calendar';
import { reset as ScreenReset } from '_redux/slices/main-screen/render-screen';
import { reset as ReviewsReset } from '_redux/slices/analytics/reviews';
import { reset as RewardsReset } from '_redux/slices/prm-club/rewards';
import { reset as UserBookingsReset } from '_redux/slices/website/userbookings';
//#endregion

// sidebar used for non verified accounts
const EmptySidebar = () => {

    // nav
    const history = useHistory();
    const dispatch = useDispatch();

    // logout 
    const handleLogout = () => {
        localStorage.clear();
        // logout and change page
        dispatch(logout());
        history.push('/login');

        // reset all slices
        dispatch(resetStatus());
        dispatch(reset())
        dispatch(HistoryReset())
        dispatch(TableReset())
        dispatch(BookingsReset())
        dispatch(CalendarReset())
        dispatch(ScreenReset())
        dispatch(ReviewsReset())
        dispatch(RewardsReset())
        dispatch(UserBookingsReset())
    }

    return (
        <div style={{ width: 80, height: '300%', borderRightStyle: 'solid', borderRightColor: '#307FE2', borderRightWidth: 0.2, backgroundColor: Colors.PRM_LIGHT_BLUE, borderTopStyle: 'solid', borderTopColor: '#F4F4F4', marginTop: -10, marginLeft: -15 }} >

            {/* Logo */}
            <div style={{ textAlign: 'center', marginTop: 30 }}>
                <img
                    src={logo}
                    style={{ width: 90, height: 'auto', padding: 10, borderRadius: 60 }}
                />
                <div style={{ marginTop: 800 }}>
                    <SidebarIcon icon={<FiLogOut size={35} color={'white'} />} handleClick={handleLogout} />
                </div>
            </div>

        </div>
    );
}

export default EmptySidebar;